import { missionEntityName } from '../../../../../backend/features/mission/shared';
import { getMissionsManageFilter } from '../../../../../backend/features/permissions/shared';
import { SelectCard } from '../../../../../ui/features/volunteers-wizard-dialog/components/SelectSection';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
export const MissionSelect = (props) => {
    const userState = useUserState();
    const { t } = useMissionsTranslation();
    const missionManagementFilter = getMissionsManageFilter(userState);
    const { data: missions } = useStorageList(missionEntityName, missionManagementFilter
        ? {
            filter: [...missionManagementFilter, { column: 'status', op: 'not-in', value: ['draft', 'closed'] }],
        }
        : undefined);
    return (React.createElement(SelectCard, Object.assign({}, props, { options: missions === null || missions === void 0 ? void 0 : missions.rows.map((mission) => ({ label: mission.columns.name, value: mission.id })), title: t('shiftVolunteerManagementWizard.titles.selectMission'), noOptionsLabel: t('shiftVolunteerManagementWizard.labels.noMissions'), selectLabel: t('shiftVolunteerManagementWizard.labels.mission'), selectLabelId: 'mission' })));
};
